<p-dialog
        [(visible)]="this.visible"
        [modal]="true"
        [header]="'Create New Firmware Revision'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '500px' }"
        (onHide)="this.close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-hashtag"></p-inputicon>
                <input
                        pInputText
                        id="sample-firmware-revision-release-version"
                        [(ngModel)]="this.sampleFirmwareRevision.releaseVersion"
                        autocomplete="off"
                        class="w-full"
                        placeholder="x.x.x"
                        [disabled]="true"
                />
            </p-iconfield>
            <label for="sample-firmware-revision-release-version">Release Version <span
                    class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-iftalabel>
            <textarea [(ngModel)]="this.sampleFirmwareRevision.description" class="w-full" id="description" pTextarea
                      rows="5"></textarea>
            <label for="description">Brief Description About This Revision <span class="text-red-500">*</span></label>
        </p-iftalabel>

        <p-ifta-label>
            <p-multiSelect
                    [options]="this.allAvailableSampleHardwareRevisions"
                    [(ngModel)]="this.compatibleSampleHardwareRevisions"
                    optionLabel="pcbVersion"
                    required
                    class="w-full"
                    id="compatible-sample-hardware-revisions"
                    filter="false"
            ></p-multiSelect>
            <label for="compatible-sample-hardware-revisions">Compatible Sample Hardware Revisions <span
                    class="text-red-500">*</span></label>
            @if (compatibleSampleHardwareRevisions && compatibleSampleHardwareRevisions.length === 0) {
                <div class="error">
                    Please select at least one item.
                </div>
            }
        </p-ifta-label>

        <p-ifta-label>
            <p-select
                    [(ngModel)]="this.selectedStatus"
                    [options]="this.allInstallationStatuses"
                    class="w-full"
                    filter="false"
                    id="sample-firmware-installation-status"
                    optionLabel="description">
            </p-select>
            <label for="sample-firmware-installation-status">Installation Status </label>
        </p-ifta-label>

        <app-upload-sample-firmware-file (fileSelected)="onFileSelected($event)"
                                         [fileName]="this.sampleFirmwareRevision.fileName"
                                         [resetTrigger]="resetUpload"></app-upload-sample-firmware-file>
        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>
    </div>
    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="this.close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Save"
                icon="pi pi-check"
                (click)="updateSampleFirmwareRevision()"
                [disabled]="this.saveDisabled"
                [loading]="this.loading"
        ></p-button>
    </div>
</p-dialog>